export function makeDefaultRecord(defaultValGenerator) {
  return new Proxy({}, {
    get: (target, name) => {
      // we only proxy out string keys otherwise weird stuff happens
      if (!(name in target) && typeof name === 'string') {
        target[name] = defaultValGenerator();
      }

      return target[name];
    }
  });
}
export function removeUndefinedProps(obj) {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    if (val !== undefined) {
      acc[key] = val;
    }

    return acc;
  }, {});
}